import axiosClient from "../../../service/axios";
import {
  EXISTING_URL,
  NEW_ORDER_URL,
  PRODUCTS_URL,
  BOAT_URL,
  NOTIFICATION_URL,
  COMPLETE_URL,
  NOTIFY_URL,
} from "./new-orders.endpoints";

/*
@create New Order

*/
const createNewOrder = async (details) => {
  try {
    return await axiosClient.post(NEW_ORDER_URL, details);
  } catch (error) {
    return error;
  }
};

const processExistingOrder = async (details) => {
  try {
    return await axiosClient.post(EXISTING_URL, details);
  } catch (error) {
    return error;
  }
};

const processBoatOrder = async (details) => {
  try {
    return await axiosClient.post(BOAT_URL, details);
  } catch (error) {
    return error;
  }
};

const processNotification = async (id) => {
  try {
    return await axiosClient.post(NOTIFICATION_URL, id);
  } catch (error) {
    return error;
  }
};

const processComplete = async (id) => {
  try {
    return await axiosClient.post(COMPLETE_URL, id);
  } catch (error) {
    return error;
  }
};

const processReturn = async (details) => {
  try {
    return await axiosClient.post(NOTIFY_URL, details);
  } catch (error) {
    return error;
  }
};

/*
@Fetch products
*/
const fetchProducts = async () => {
  try {
    return await axiosClient.get(PRODUCTS_URL);
  } catch (error) {
    return error;
  }
};

const NewOrderService = {
  createNewOrder,
  fetchProducts,
  processExistingOrder,
  processBoatOrder,
  processNotification,
  processComplete,
  processReturn,
};

export default NewOrderService;
